import { render, staticRenderFns } from "./UserReplyIndex.vue?vue&type=template&id=471d8821&"
import script from "./UserReplyIndex.vue?vue&type=script&lang=js&"
export * from "./UserReplyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports